"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerUsersTable = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importStar(require("react"));
const react_table_1 = require("react-table");
const configContext_1 = require("../../context/configContext");
require("./ManagerTables.scss");
const SimpleModal_1 = require("../simple-modal/SimpleModal");
const IconDelete_1 = require("../icons/IconDelete");
/**
 * Table for users.
 */
const ManagerUsersTable = (props) => {
    const config = (0, configContext_1.useConfig)();
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    function handleDelete(user) {
        // Show delete confirmation.
        showModal(react_1.default.createElement(SimpleModal_1.SimpleModal, { className: "", title: "\uD83D\uDE2E Benutzer entfernen?", body: react_1.default.createElement("p", null, "Soll ich den Benutzer entfernen?"), onClose: hideModal, onOk: () => {
                // Remove from member/admin.
                const userClone = (0, cloneDeep_1.default)(user);
                userClone.adminOf = userClone.adminOf.filter((t) => t !== config.tenantId);
                userClone.memberOf = userClone.memberOf.filter((t) => t !== config.tenantId);
                props.onUserMembershipsChange(userClone);
                hideModal();
            } }));
    }
    const columns = (0, react_1.useMemo)(() => {
        const cols = [];
        cols.push({
            Header: "Name",
            accessor: (row) => row.name,
        });
        cols.push({
            Header: "E-Mail",
            accessor: (row) => row.email,
        });
        cols.push({
            Header: "Mitgliedschaft",
            accessor: (row) => {
                return (react_1.default.createElement("select", { name: "membership", onChange: (e) => {
                        const userClone = (0, cloneDeep_1.default)(row);
                        if (e.target.value === "admin") {
                            // Add as admin if not already present.
                            if (!userClone.isAdminOf(config.tenantId)) {
                                userClone.adminOf.push(config.tenantId);
                                props.onUserMembershipsChange(userClone);
                            }
                        }
                        else {
                            // Remove from admin.
                            userClone.adminOf = userClone.adminOf.filter((t) => t !== config.tenantId);
                            props.onUserMembershipsChange(userClone);
                        }
                    }, value: row.isAdminOf(config.tenantId) ? "admin" : "member" },
                    react_1.default.createElement("option", { value: "member" }, "Mitglied"),
                    react_1.default.createElement("option", { value: "admin" }, "Administrator")));
            },
        });
        cols.push({
            Header: "Entfernen",
            accessor: (row) => (react_1.default.createElement("a", { className: "icon-delete no-print", title: "Benutzer entfernen", onClick: () => handleDelete(row) },
                react_1.default.createElement(IconDelete_1.IconDelete, null))),
        });
        return cols;
    }, []);
    // Prepare data.
    // Sort.
    const data = (0, sortBy_1.default)(props.users, [(row) => row.name]);
    // Init table.
    const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows, } = (0, react_table_1.useTable)({
        columns,
        data,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "manager-users-table table-responsive" },
            react_1.default.createElement("table", { ...getTableProps(), id: "table", className: "table table-sm sticky-header" },
                react_1.default.createElement("thead", null, headerGroups.map((headerGroup) => (react_1.default.createElement("tr", { ...headerGroup.getHeaderGroupProps() }, headerGroup.headers.map((column) => (react_1.default.createElement("th", { ...column.getHeaderProps() }, column.render("Header")))))))),
                react_1.default.createElement("tbody", { ...getTableBodyProps() }, rows.map((row, i) => {
                    prepareRow(row);
                    return (react_1.default.createElement("tr", { ...row.getRowProps() }, row.cells.map((cell) => {
                        return (react_1.default.createElement("td", { ...cell.getCellProps() }, cell.render("Cell")));
                    })));
                }))),
            data.length === 0 && (react_1.default.createElement("div", { className: "text-center text-secondary" }, "Keine Daten"))),
        modal));
};
exports.ManagerUsersTable = ManagerUsersTable;
